var appEnv = "";
var s3region = "";
var s3rootfolder = "";
var s3envfolder = "samples";
var endpoints = {};
var okta = {};
var ldClientSideId = "";
var isLocalHost = window.location.hostname === "localhost";

switch (window.location.hostname) {
  case "onetool.bio-rad.com":
  case "d10xyxtb417egc.cloudfront.net":
    appEnv = "prod";
    s3region = "us-west-2";
    s3rootfolder = `dbg-sample-tracking-data-${appEnv}`;
    endpoints = {
      s3bucketroot: `https://s3.${s3region}.amazonaws.com`,
      s3bucket: `https://s3.${s3region}.amazonaws.com/${s3rootfolder}`,
      main: "https://2zwhwal4d0.execute-api.us-west-2.amazonaws.com/prod",
      datalake: "https://ngnyg22bpe.execute-api.us-west-2.amazonaws.com/prod",
      qlpbucket: `biorad-qlp-${appEnv}`,
      ddpcrbucket: `biorad-ddpcr-${appEnv}`,
      uploadUrl: `https://s3.${s3region}.amazonaws.com`
    };
    okta = {
      url: "https://biorad-ext.okta.com",
      issuer: "https://biorad-ext.okta.com/oauth2/default",
      redirect_uri: `https://${window.location.hostname}/login/callback`,
      client_id: "0oa17ddkju1UrRRVs2p8",
    };
    ldClientSideId = "6a209f98d1b0830a9d7358d5";
    break;

  case "dq56h7loujbbc.cloudfront.net":
    appEnv = "dev";
    s3region = "us-west-2";
    s3rootfolder = `dbg-sample-tracking-data-${appEnv}`;
    endpoints = {
      s3bucketroot: `https://s3.${s3region}.amazonaws.com`,
      s3bucket: `https://s3.${s3region}.amazonaws.com/${s3rootfolder}`,
      main: "https://4eb3v5vm6f.execute-api.us-west-2.amazonaws.com/dev",
      datalake: "https://sybzsqt9tl.execute-api.us-west-2.amazonaws.com/dev",
      qlpbucket: `biorad-qlp-${appEnv}`,
      ddpcrbucket: `biorad-ddpcr-${appEnv}`,
      uploadUrl: `https://s3.${s3region}.amazonaws.com`
    };
    okta = {
      url: "https://biorad-ext.okta.com",
      issuer: "https://biorad-ext.okta.com/oauth2/default",
      redirect_uri: `https://${window.location.hostname}/login/callback`,
      client_id: "0oa17ddkju1UrRRVs2p8",
    };
    ldClientSideId = "6a209f98d1b0830a9d7358d4";
    break;

  case "d31gq6cdhngx30.cloudfront.net":
    appEnv = "test";
    s3region = "us-west-2";
    s3rootfolder = `dbg-sample-tracking-data-${appEnv}`;
    endpoints = {
      s3bucketroot: `https://s3.${s3region}.amazonaws.com`,
      s3bucket: `https://s3.${s3region}.amazonaws.com/${s3rootfolder}`,
      main: "https://x19rze1877.execute-api.us-west-2.amazonaws.com/test",
      datalake: "https://6d129a4f7b.execute-api.us-west-2.amazonaws.com/test",
      qlpbucket: `biorad-qlp-${appEnv}`,
      ddpcrbucket: `biorad-ddpcr-${appEnv}`,
      uploadUrl: `https://s3.${s3region}.amazonaws.com`
    };
    okta = {
      url: "https://biorad-ext.okta.com",
      issuer: "https://biorad-ext.okta.com/oauth2/default",
      redirect_uri: `https://${window.location.hostname}/login/callback`,
      client_id: "0oa17ddkju1UrRRVs2p8",
    };
    ldClientSideId = "6a209f98d1b0830a9d7358d4";
    break;

  default:
    appEnv = "dev"; // default to dev for local development.
    s3region = "us-west-2";
    s3rootfolder = `dbg-sample-tracking-data-${appEnv}`;
    endpoints = {
      s3bucketroot: `https://s3.${s3region}.amazonaws.com`,
      s3bucket: `https://s3.${s3region}.amazonaws.com/${s3rootfolder}`,
      main: isLocalHost
        ? "http://localhost:5000"
        : "https://4eb3v5vm6f.execute-api.us-west-2.amazonaws.com/dev",
      datalake: isLocalHost
        ? "https://sybzsqt9tl.execute-api.us-west-2.amazonaws.com/dev"
        : "https://sybzsqt9tl.execute-api.us-west-2.amazonaws.com/dev",
      qlpbucket: `biorad-qlp-${appEnv}`,
      ddpcrbucket: `biorad-ddpcr-${appEnv}`,
      uploadUrl: `https://s3.${s3region}.amazonaws.com`
    };
    okta = {
      url: "https://biorad-ext.okta.com",
      issuer: "https://biorad-ext.okta.com/oauth2/default",
      redirect_uri: `http://localhost:3000/login/callback`,
      client_id: "0oa17ddkju1UrRRVs2p8",
    };
    ldClientSideId = "6a209f98d1b0830a9d7358d4";
}

export const APPENV = appEnv;
export const S3REGION = s3region;
export const S3ROOTFOLDER = s3rootfolder;
export const S3ENVFOLDER = s3envfolder;

export const ENDPOINTS = {
  s3BucketRoot: endpoints["s3bucketroot"],
  s3Bucket: endpoints["s3bucket"],
  main: endpoints["main"],
  datalake: endpoints["datalake"],
  uploadUrl: endpoints["uploadUrl"],
  qlpbucket: endpoints["qlpbucket"],
  ddpcrbucket: endpoints["ddpcrbucket"]
};

export default {
  url: okta["url"],
  issuer: okta["issuer"],
  redirect_uri: okta["redirect_uri"],
  client_id: okta["client_id"],
  ldClientSideId: ldClientSideId,
};
